import React from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import Style from './ActionButton.module.scss';

const ActionButton = ({
  clickHandler = () => {},
  icon = null,
  shouldRender = true,
  text = null,
  url = null,
}) => {
  if (!shouldRender) return null;
  return url ? (
    <Link to={url} className={Style.actionLink} onClick={clickHandler} onlyActiveOnIndex>
      <button
        className={classNames(Style.actionButton, Style[icon])}
        type="button"
        aria-label={text}
      >
        <div className={Style.iconContainer}>
          <Icon icon={icon} color="white" size="full" />
        </div>
        <label className={Style.label}>{text}</label>
      </button>
    </Link>
  ) : (
    <div className={Style.actionLink}>
      <button
        className={classNames(Style.actionButton, Style.filled, Style[icon])}
        onClick={clickHandler}
        type="button"
        aria-label={text}
      >
        <div className={Style.iconContainer}>
          <Icon icon={icon} color="white" size="full" />
        </div>
        <label className={Style.label}>{text}</label>
      </button>
    </div>
  );
};

ActionButton.propTypes = {
  clickHandler: PropTypes.func,
  icon: PropTypes.string,
  shouldRender: PropTypes.bool,
  text: PropTypes.string,
  url: PropTypes.string,
};

export default ActionButton;
